import axios from 'axios';

export const signIn = (credentials) => {
  const { email, password } = credentials;
  return (dispatch, getState) => {
    axios({
      url: process.env.REACT_APP_API_URL+'/login/email',
      method: 'post',
      data: {
        email,
        password
      },
      withCredentials:true
    }).then((res) => {
      if (res.data.success === 1) {
        dispatch({ type: 'LOGIN_SUCCESS', payload: { data: res.data.data } });
      } else {
        dispatch({ type: 'LOGIN_ERROR', err: res.data.msg });
      }
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err });
    });
  }
}

export const signOut = () => {
  return (dispatch) => {
    axios({
      url: process.env.REACT_APP_API_URL+'/login/logout',
      method: 'post',
      withCredentials:true
    }).then((res) => {
      if (res.data.success === 1) {
        dispatch({ type: 'SIGNOUT_SUCCESS' });
      }
    })
  }
}